/**
 * User Soft Delete / User Lifecycle (2026-09-02): the "(Inactive)" suffix
 * is no longer computed in the frontend at all -- `users.display_name` is
 * a Postgres `generated always as (...) stored` column (see
 * backend/migrations/phase35_users_display_name.sql) that recomputes
 * automatically whenever first_name/last_name/deleted_at change,
 * including via soft_delete_user(). Any query that wants a user's name
 * for display just selects `display_name` -- one column, always correct,
 * impossible to forget the "(Inactive)" logic on a new call site the way
 * the previous per-consumer `first_name`+`last_name`+`deleted_at` +
 * formatter approach was.
 *
 * This helper now only does null-safety for callers whose embed/lookup
 * came back empty (e.g. a dangling created_by with no matching row).
 */

export interface DisplayableUser {
  display_name?: string | null;
}

export function formatUserDisplayName(user?: DisplayableUser | null, fallback = 'Unknown User'): string {
  return user?.display_name || fallback;
}
